'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var styled = require('styled-components');
var hooks_useCombinedClassName = require('./hooks/use-combined-class-name/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _excluded = ["className", "icon", "spanRef"];
var _templateObject;
/**
 * Span wrapper for the icon
 */
var OwnUpStyledIcon = styled__default['default'].span(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  & svg {\n    width: ", ";\n    height: ", ";\n  }\n  & path {\n    /* Use the theme text color if not provided */\n    fill: ", ";\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height ? height : '1.25rem';
}, function (_ref2) {
  var height = _ref2.height;
  return height ? height : '1.25rem';
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color || theme.palette.text.primary;
});

/**
 * Render a span that contains a defined icon.
 *
 * @param props See {@link OwnUpIconProps}
 */
var OwnUpIcon = function OwnUpIcon(_ref4) {
  var className = _ref4.className,
    Icon = _ref4.icon,
    spanRef = _ref4.spanRef,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref4, _excluded);
  // Icon could be a functional component or a simple JSX element.
  //   Use this helper function to handle either.
  var renderedIcon = React.useMemo(function () {
    return typeof Icon === 'function' ? /*#__PURE__*/React__default['default'].createElement(Icon, null) : Icon;
  }, [Icon]);
  return /*#__PURE__*/React__default['default'].createElement(OwnUpStyledIcon, _rollupPluginBabelHelpers._extends({
    ref: spanRef
  }, props, {
    className: hooks_useCombinedClassName.useCombinedClassName(className, 'ou-icon')
  }), renderedIcon);
};

exports.OwnUpIcon = OwnUpIcon;
//# sourceMappingURL=component-21a580e6.js.map
